import { Box, Chip, TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useState } from "react";

const channelOptions = [
  { id: "whatsapp", name: "WhatsApp" },
  { id: "whatsapp_oficial", name: "WhatsApp Oficial" },
  { id: "wuzapi", name: "WuzAPI" },
  { id: "facebook", name: "Facebook" },
  { id: "instagram", name: "Instagram" },
  { id: "telegram", name: "Telegram" },
  { id: "email", name: "Email" },
  { id: "webchat", name: "WebChat" },
];

export function ChannelFilter({ onFiltered }) {
  const [selecteds, setSelecteds] = useState([]);

  const onChange = (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box>
      <Autocomplete
        multiple
        size="small"
        options={channelOptions}
        value={selecteds}
        onChange={(e, v) => onChange(v)}
        getOptionLabel={(option) => option.name}
        getOptionSelected={(option, value) => option.id === value.id}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{ borderRadius: 4 }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="Canal"
            label="Canal"
          />
        )}
      />
    </Box>
  );
}

export default ChannelFilter;
